import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home";
import Download from '../components/Download'
import Help from '../components/Help'
import About from "../components/About";
import Browse from "../components/Browse";
import DeepFusion from "../components/DeepFusion";
import Functionalities from "../components/Functionalities";
import JBrowse from "../components/JBrowse";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/browse',
      name: 'browse',
      component: Browse
    },
    {
      path: '/deepfusion',
      name: 'deepfusion',
      component: DeepFusion
    },
    {
      path: '/download',
      name: 'download',
      component: Download
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/functionalities',
      name: 'functionalities',
      component: Functionalities,
    },
    {
      path: '/jbrowse',
      name: 'jbrowse',
      component: JBrowse
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js